const appData = {
    current: ''
};

export default appData;